module.exports = __webpack_public_path__ + "img/logo-zendesk.a396397e.png";